'use client';

import { useAnalyticsService } from '@shared/contexts/AnalyticsServiceContext';
import { Header, Link, Text } from '@inato/ui';
import { useEffect } from 'react';

import { usePlatformService } from '../../PlatformContext';
import { CONTACT_US_EMAIL } from '../constants/emails';
import { BreadcrumbPlaceholder } from './BreadcrumbPlaceholder';

export const PageNotFound = () => {
  const analyticsService = useAnalyticsService();
  useEffect(() => {
    // This logPage is one of the rare ad hoc triggers - see #useAutomatedPageViewAnalytics for the generic trigger
    analyticsService.logPage({ name: 'Page not found' });
  }, [analyticsService]);
  const platformService = usePlatformService();

  return (
    <div className="mt-l desktop:mt-xl m-auto flex max-w-[640px] flex-col leading-6">
      <BreadcrumbPlaceholder />
      <Header className="mb-xl" tag="h1" size="5xl">
        Page not found
      </Header>
      <Text asSpan size="l">
        You can first try to{' '}
        <Link onClick={platformService.reload}>refresh the page</Link>.
      </Text>
      <Text asSpan size="l">
        If you think there is a problem with this link, email us at{' '}
        <Link href={`mailto:${CONTACT_US_EMAIL}`}>{CONTACT_US_EMAIL}</Link>
      </Text>
      <Text asSpan size="l">
        <Link href="/">Go to the home page</Link>
      </Text>
    </div>
  );
};
